// extracted by mini-css-extract-plugin
module.exports = {"error-message__border":"style_error-message__border__o56fO","error-message__text":"style_error-message__text__ge5fQ"};